var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.1,
    height: 78.602,
    viewBox: "0 0 50.056 39.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #9c0b2c;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    className: "cls-1",
    d: "M670.367,522.625c-5.395,5.657-1.316,11.683-.546,19.1s-3.871,6.419-3.871,6.419c2.276-5.712.046-10.586-4.494-12.859s-10.218.982-11.517,5.547,2.213,8.378,2.213,8.378c-6.88.042-9.812-4.972-10.032-9.131s4.409-7.045,7.2-13.667-2.78-9.592-2.78-9.592A8.7,8.7,0,0,0,634.9,518.3c-.33.8,2.133,1.193,2.133,1.193l-.013.013c-.9.076-3.571.076-4.87-2.192a3.8,3.8,0,0,0,.893,1.494,5.481,5.481,0,0,1-1.709-.148s2.793,1.65,5.327,1.108l-1.561,1.138s2,2.078,7.832,2.111.394,6.288-1.735,8.97S631.025,543.561,640,550.437s21.5,3,21.5,3c15.186.478,11.89-12.372,9.74-18.909s-.229-10.244,2.644-11.856c3.745-2.107,7.5,1.659,7.5,1.659-.14-2.606-5.636-7.362-11.022-1.705m-30.029-3.435a.939.939,0,0,1-1-.745.527.527,0,0,0,.351.085.584.584,0,0,0,.542-.635.6.6,0,0,0-.368-.5.884.884,0,0,1,.33-.085.944.944,0,0,1,1.007.867.935.935,0,0,1-.863,1.011m18.647,29.39a4.709,4.709,0,1,1,3.981-5.014,4.538,4.538,0,0,1-3.981,5.014",
    transform: "translate(-631.334 -515.226)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiRed);
export default __webpack_public_path__ + "static/media/tiRed.5537897378e11d08edaa861c0161e436.svg";
export { ForwardRef as ReactComponent };